// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"277":"b229e7cb","623":"b229e7cb"}[chunkId] + ".chunk.css");